module.exports = __webpack_public_path__ + "media/soundtrack.d7ea552b.mp3";